import { render } from "./FloattingButtonVimass.vue?vue&type=template&id=623d9fe8&scoped=true"
import script from "./FloattingButtonVimass.vue?vue&type=script&lang=js"
export * from "./FloattingButtonVimass.vue?vue&type=script&lang=js"

import "./FloattingButtonVimass.vue?vue&type=style&index=0&id=623d9fe8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623d9fe8"]])

export default __exports__